import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaAppBarPinnedApps" */ './lazyIndex'),
    { name: 'OwaAppBarPinnedApps' }
);

export const lazyInitializeAppBarPinnedAppsUserSetting: LazyAction<
    typeof lazyIndex.initializeAppBarPinnedAppsUserSetting,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeAppBarPinnedAppsUserSetting);
